(() => {
  "use strict";

  if (window.__ONLYDREAM_LOOKBOOK_2026__) {
    return;
  }

  window.__ONLYDREAM_LOOKBOOK_2026__ = true;

  const BUTTON_SELECTOR = "[data-look-add]";
  const CART_DRAWER_SELECTOR = "#CartDrawer";
  const DRAWER_OPENER_SELECTOR =
    '[data-sidebar-button][data-sidebar-id="CartDrawer"]';

  const DEFAULT_ERROR =
    "Non è stato possibile aggiungere il look al carrello.";

  function getRoot() {
    return window.Shopify?.routes?.root || "/";
  }

  function getCartAddUrl() {
    return (
      window.routes?.cart_add_url ||
      `${getRoot()}cart/add.js`
    );
  }

  function parseVariantIds(button) {
    try {
      const parsed = JSON.parse(
        button.dataset.variantIds || "[]"
      );

      return [
        ...new Set(
          parsed
            .map((id) => Number(id))
            .filter((id) => Number.isInteger(id) && id > 0)
        )
      ];
    } catch (error) {
      console.error(
        "[Lookbook 2026] Invalid variant IDs",
        error
      );

      return [];
    }
  }

  function getFeedbackElement(button) {
    const card = button.closest("[data-look-card]");

    if (!card) {
      return null;
    }

    let feedback = card.querySelector(
      "[data-look-feedback]"
    );

    if (!feedback) {
      feedback = document.createElement("p");
      feedback.className =
        "lookbook-card__feedback";
      feedback.dataset.lookFeedback = "";
      feedback.setAttribute("role", "status");
      feedback.setAttribute(
        "aria-live",
        "polite"
      );

      const actions = card.querySelector(
        ".lookbook-card__actions"
      );

      actions?.insertAdjacentElement(
        "afterend",
        feedback
      );
    }

    return feedback;
  }

  function setFeedback(
    button,
    message = "",
    status = ""
  ) {
    const feedback =
      getFeedbackElement(button);

    if (!feedback) {
      return;
    }

    feedback.textContent = message;

    if (status) {
      feedback.dataset.status = status;
    } else {
      delete feedback.dataset.status;
    }
  }

  function showGlobalNotification(
    message,
    type = "warning"
  ) {
    const bodyElement =
      document.querySelector("body-element");

    if (
      bodyElement &&
      typeof bodyElement.showNotification ===
        "function"
    ) {
      bodyElement.showNotification(
        message,
        type
      );
    }
  }

  function getErrorMessage(payload) {
    const description =
      payload?.description ||
      payload?.message ||
      payload?.errors ||
      DEFAULT_ERROR;

    if (
      description &&
      typeof description === "object"
    ) {
      return Object.entries(description)
        .map(([key, value]) => {
          return `${key}: ${value}`;
        })
        .join(", ");
    }

    return String(description);
  }

  function setButtonLoading(
    button,
    loading
  ) {
    const textElement =
      button.querySelector(
        "[data-button-text]"
      );

    if (!button.dataset.defaultText) {
      button.dataset.defaultText =
        textElement?.textContent?.trim() ||
        button.textContent.trim();
    }

    button.classList.toggle(
      "loading",
      loading
    );

    button.toggleAttribute(
      "aria-busy",
      loading
    );

    if (loading) {
      button.disabled = true;

      if (textElement) {
        textElement.textContent =
          "Aggiungo il look…";
      }

      return;
    }

    const availableCount = Number(
      button.dataset.availableCount || 0
    );

    button.disabled =
      !Number.isFinite(availableCount) ||
      availableCount <= 0;

    if (textElement) {
      textElement.textContent =
        button.dataset.defaultText;
    }
  }

  async function postItems(
    variantIds,
    cartSectionId
  ) {
    const payload = {
      items: variantIds.map((id) => ({
        id,
        quantity: 1
      }))
    };

    if (cartSectionId) {
      payload.sections = [
        cartSectionId
      ];

      payload.sections_url =
        window.location.pathname;
    }

    const response = await fetch(
      getCartAddUrl(),
      {
        method: "POST",
        credentials: "same-origin",
        headers: {
          Accept: "application/json",
          "Content-Type":
            "application/json",
          "X-Requested-With":
            "XMLHttpRequest"
        },
        body: JSON.stringify(payload)
      }
    );

    const responseText =
      await response.text();

    let data;

    try {
      data = JSON.parse(responseText);
    } catch (error) {
      data = {
        message:
          "Il carrello ha restituito una risposta non valida."
      };
    }

    if (!response.ok) {
      const cartError =
        new Error(
          getErrorMessage(data)
        );

      cartError.status =
        response.status;

      cartError.payload = data;

      throw cartError;
    }

    return data;
  }

  function createAuroraState(
    responseData,
    addedCount
  ) {
    const firstItem =
      responseData?.items?.[0] ||
      responseData ||
      {};

    return {
      ...firstItem,
      quantity:
        Number(firstItem.quantity) ||
        addedCount,
      items:
        responseData?.items || []
    };
  }

  async function updateAuroraDrawer(
    responseData,
    addedCount
  ) {
    const cartDrawer =
      document.querySelector(
        CART_DRAWER_SELECTOR
      );

    const cartSectionId =
      cartDrawer?.dataset?.sectionId ||
      "";

    const sectionHTML =
      cartSectionId
        ? responseData?.sections?.[
            cartSectionId
          ]
        : "";

    if (
      cartDrawer &&
      sectionHTML &&
      typeof cartDrawer.purchaseHandler ===
        "function"
    ) {
      const parsedHTML =
        new DOMParser().parseFromString(
          sectionHTML,
          "text/html"
        );

      const auroraState =
        createAuroraState(
          responseData,
          addedCount
        );

      cartDrawer
        .updateAsideProductsByParsedState
        ?.(auroraState);

      cartDrawer.updateEmptyStatus?.();

      await cartDrawer.purchaseHandler(
        parsedHTML,
        auroraState
      );

      return true;
    }

    const opener =
      document.querySelector(
        DRAWER_OPENER_SELECTOR
      );

    if (opener) {
      opener.click();
      return true;
    }

    return false;
  }

  async function addAvailableItemsSeparately(
    variantIds,
    cartSectionId
  ) {
    const successfulIds = [];
    const failedIds = [];
    let latestResponse = null;

    for (const variantId of variantIds) {
      try {
        latestResponse =
          await postItems(
            [variantId],
            cartSectionId
          );

        successfulIds.push(
          variantId
        );
      } catch (error) {
        failedIds.push(
          variantId
        );

        console.warn(
          "[Lookbook 2026] Variant skipped",
          {
            variantId,
            status: error.status,
            message: error.message
          }
        );
      }
    }

    return {
      successfulIds,
      failedIds,
      latestResponse
    };
  }

  async function handleLookAdd(button) {
    if (
      button.dataset.lookAdding ===
        "true" ||
      button.disabled
    ) {
      return;
    }

    const variantIds =
      parseVariantIds(button);

    if (variantIds.length === 0) {
      const message =
        "Nessun capo disponibile per questo look.";

      setFeedback(
        button,
        message,
        "error"
      );

      showGlobalNotification(
        message
      );

      return;
    }

    const cartDrawer =
      document.querySelector(
        CART_DRAWER_SELECTOR
      );

    const cartSectionId =
      cartDrawer?.dataset?.sectionId ||
      "";

    button.dataset.lookAdding = "true";

    setFeedback(button);
    setButtonLoading(
      button,
      true
    );

    try {
      const responseData =
        await postItems(
          variantIds,
          cartSectionId
        );

      await updateAuroraDrawer(
        responseData,
        variantIds.length
      );

      setFeedback(
        button,
        variantIds.length === 1
          ? "Capo aggiunto al carrello."
          : `${variantIds.length} capi aggiunti al carrello.`,
        "success"
      );
    } catch (error) {
      if (error.status !== 422) {
        throw error;
      }

      /*
       * Shopify rejected the multi-add.
       * Retry the same IDs one at a time, skip
       * the unavailable one and keep the rest.
       */
      const fallback =
        await addAvailableItemsSeparately(
          variantIds,
          cartSectionId
        );

      if (
        fallback.successfulIds.length ===
          0 ||
        !fallback.latestResponse
      ) {
        throw error;
      }

      await updateAuroraDrawer(
        fallback.latestResponse,
        fallback.successfulIds.length
      );

      const totalCount =
        variantIds.length;

      const addedCount =
        fallback.successfulIds.length;

      const message =
        `Aggiunti ${addedCount} capi su ${totalCount}. ` +
        "Gli altri non sono più disponibili.";

      setFeedback(
        button,
        message,
        "warning"
      );

      showGlobalNotification(
        message
      );
    } finally {
      button.dataset.lookAdding =
        "false";

      setButtonLoading(
        button,
        false
      );
    }
  }

  function ensureStyles() {
    if (
      document.getElementById(
        "Lookbook2026ScriptStyles"
      )
    ) {
      return;
    }

    const style =
      document.createElement("style");

    style.id =
      "Lookbook2026ScriptStyles";

    style.textContent = `
      .lookbook-card__feedback {
        margin: 10px 0 0;
        font-size: 0.875rem;
        line-height: 1.4;
      }

      .lookbook-card__feedback:empty {
        display: none;
      }

      .lookbook-card__feedback[data-status="success"] {
        color: var(--gsc-success-color, currentColor);
      }

      .lookbook-card__feedback[data-status="warning"],
      .lookbook-card__feedback[data-status="error"] {
        color: var(--gsc-error-color, currentColor);
      }
    `;

    document.head.appendChild(style);
  }

  ensureStyles();

  document.addEventListener(
    "click",
    (event) => {
      const button =
        event.target.closest(
          BUTTON_SELECTOR
        );

      if (!button) {
        return;
      }

      event.preventDefault();

      handleLookAdd(button).catch(
        (error) => {
          console.error(
            "[Lookbook 2026]",
            error
          );

          const message =
            error?.message ||
            DEFAULT_ERROR;

          setFeedback(
            button,
            message,
            "error"
          );

          showGlobalNotification(
            message
          );

          button.dataset.lookAdding =
            "false";

          setButtonLoading(
            button,
            false
          );
        }
      );
    }
  );
})();
